import AbstractModel, { Model, DateType } from './abstract-model';

export const FLEX_PROFILES = {
  LECTEUR: "lecteur",
  AGENT_SAISIE: "saisisseur",
  VALIDEUR: "valideur",
  REF_THEM: "referent",
  
  POC_LECTEUR: "lecteur poc",
  POC_AGENT_SAISIE: "saisisseur poc",
  POC_VALIDEUR: "valideur poc",
  
  CUS_LECTEUR: "lecteur cus",
  CUS_AGENT_SAISIE: "saisisseur cus",
  CUS_VALIDEUR: "valideur cus",

  DDTM59_GESTIONNAIRE: "gestionnaire ddtm59"
};

@Model('User')
export default class User extends AbstractModel {
  
  public id: number = 0;
  public luid: string = null;
  public mail: string = null;
  public nom: string = null;
  public prenom: string = null;
  public type: string = "siepeople";
  public password: string = null;
  @DateType() public loginDate: Date = null;
  public profileName: string[];
  public description: string = null;
  public depts: string = null;
  public flexProfile: string[];

  public hasFlexProfile(v: string): boolean {
    return this.flexProfile.some(fp => fp === v);
  }

  public hasHigherFlexProfileThan(v: string): boolean {

    const {
      LECTEUR,
      AGENT_SAISIE,
      VALIDEUR,
      REF_THEM,
      POC_LECTEUR,
      POC_AGENT_SAISIE,
      POC_VALIDEUR,
      CUS_LECTEUR,
      CUS_AGENT_SAISIE,
      CUS_VALIDEUR,
      DDTM59_GESTIONNAIRE
    } = FLEX_PROFILES;
		
    if (v == POC_LECTEUR)
      return this.hasMinimumFlexProfile(POC_AGENT_SAISIE)
    else if (v == POC_AGENT_SAISIE)
      return this.hasFlexProfile(POC_VALIDEUR) || this.hasFlexProfile(REF_THEM);
    else if (v == CUS_LECTEUR)
      return this.hasMinimumFlexProfile(CUS_AGENT_SAISIE)
    else if (v == CUS_AGENT_SAISIE)
      return this.hasFlexProfile(CUS_VALIDEUR) || this.hasFlexProfile(REF_THEM);
    else if (v == LECTEUR)
      return this.hasMinimumFlexProfile(AGENT_SAISIE);
    else if (v == AGENT_SAISIE)
      return this.hasMinimumFlexProfile(VALIDEUR);
    else if (v == VALIDEUR)
      return this.hasFlexProfile(REF_THEM);
    else
      return false;
  }

  public hasMinimumFlexProfile(v: string): boolean {
    return this.hasFlexProfile(v) || this.hasHigherFlexProfileThan(v);
  }

  public get hasPocAcces() {
    return this.hasMinimumFlexProfile(FLEX_PROFILES.POC_LECTEUR);
  }

  public get hasEmsAcces() {
    return this.hasMinimumFlexProfile(FLEX_PROFILES.CUS_LECTEUR);
  }

  public get hasDdtm59Acces() {
    return this.hasMinimumFlexProfile(FLEX_PROFILES.DDTM59_GESTIONNAIRE);
  }

}

